import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=82a6a63e&"
import script from "./multipleChoice.vue?vue&type=script&lang=js&"
export * from "./multipleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports